import { DocumentationPage } from './_article.jsx';
export default function ImportingAPodcastPage({
  article,
  articles
}) {
  return <DocumentationPage article={article} articles={articles} />;
}